import moment from "moment-timezone";

const getDefaultFormattedTime = (timestamp, timezone) => {
  const localTimezone = moment.tz.guess();
  const nowMoment = moment().tz(timezone ?? localTimezone);
  const timestampMoment = moment(timestamp).tz(timezone ?? localTimezone);
  if (timestampMoment.isSame(nowMoment, "day")) {
    return `Today \u2022 ${timestampMoment.format(
      `HH:mm${timezone ? " z" : ""}`
    )}`;
  } else if (
    timestampMoment.isAfter(nowMoment.clone().subtract(7, "days"), "day")
  ) {
    return timestampMoment.format(`dddd \u2022 HH:mm${timezone ? " z" : ""}`);
  } else if (
    timestampMoment.isAfter(nowMoment.clone().subtract(1, "years"), "month")
  ) {
    return timestampMoment.format(
      `dddd, MMM D \u2022 HH:mm${timezone ? " z" : ""}`
    );
  } else {
    return timestampMoment.format(
      `dddd, MMM D, YYYY \u2022 HH:mm${timezone ? " z" : ""}`
    );
  }
};

export default getDefaultFormattedTime;
